import axios from 'axios';

// Use REACT_APP_BACKEND_URL for API base (set to emergent.host on deployed builds).
// CORS is handled by backend middleware.
const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const API = axios.create({
    baseURL: `${API_BASE}/api`,
    headers: { 'Content-Type': 'application/json' }
});

// Attach Bearer token from localStorage on every request
API.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Auto-refresh on 401 and store tokens from login/register responses
API.interceptors.response.use(
    (response) => {
        const data = response.data;
        if (data && data.access_token) {
            localStorage.setItem('access_token', data.access_token);
        }
        if (data && data.refresh_token) {
            localStorage.setItem('refresh_token', data.refresh_token);
        }
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            const refreshToken = localStorage.getItem('refresh_token');
            if (refreshToken) {
                try {
                    const res = await axios.post(
                        `${API_BASE}/api/auth/refresh`,
                        { refresh_token: refreshToken }
                    );
                    if (res.data.access_token) {
                        localStorage.setItem('access_token', res.data.access_token);
                        originalRequest.headers.Authorization = `Bearer ${res.data.access_token}`;
                        return API(originalRequest);
                    }
                } catch (refreshError) {
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('refresh_token');
                }
            }
        }
        return Promise.reject(error);
    }
);

export function clearAuthTokens() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
}

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map(e => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default API;
